import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import InfoBox from 'components/Shared/InfoBox'
import SelectItem from 'components/Shared/SelectItem'
import { GoogleCampaignType } from './campaignType'

// Demand Gen listed first, matching the Figma frame's option order.
const CAMPAIGN_TYPE_OPTIONS = [GoogleCampaignType.demandGen, GoogleCampaignType.display]

const CampaignType = ({ selectedCampaignType, onCampaignTypeSelected, disabled = false }) => {
  const { t } = useTranslation()

  return (
    <div className="d-flex flex-column h-100">
      <InfoBox
        title={t('Tips.Recommendations.SelectCampaignType.title')}
        body={t('Tips.Recommendations.SelectCampaignType.body')}
        placement="bottom"
      >
        <h2 className="d-inline-block section-title">
          {t('Recommendations.campaignType.selectLabel')}
        </h2>
      </InfoBox>
      <div
        className="campaign-type-wrapper h-100"
      >
        {CAMPAIGN_TYPE_OPTIONS.map((campaignType) => {
          const optionLabel = t(`Recommendations.campaignType.options.${campaignType}.label`)
          const optionDescription = t(
            `Recommendations.campaignType.options.${campaignType}.description`,
          )
          return (
            <SelectItem
              key={campaignType}
              checked={campaignType === selectedCampaignType}
              onChange={() => onCampaignTypeSelected(campaignType)}
              disabled={disabled}
              title={optionLabel}
              description={optionDescription}
            />
          )
        })}
      </div>
    </div>
  )
}

CampaignType.propTypes = {
  selectedCampaignType: PropTypes.oneOf(Object.values(GoogleCampaignType)).isRequired,
  onCampaignTypeSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default CampaignType
